export const common = {
  appName: 'Acework',
  appTagline: 'Tennis Community',
  
  // Navigation
  matches: 'Matches',
  stats: 'Stats',
  tournaments: 'Tournaments',
  profile: 'Profile',
  
  // Common actions
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  edit: 'Edit',
  back: 'Back',
  next: 'Next',
  submit: 'Submit',
  confirm: 'Confirm',
  close: 'Close',
  
  // Match related
  win: 'Win',
  loss: 'Loss',
  vs: 'VS',
  score: 'Score',
  date: 'Date',
  location: 'Location',
  opponent: 'Opponent',
  singles: 'Singles',
  doubles: 'Doubles',
  joined: 'joined',
  ranked: 'Ranked',
  
  // Stats
  totalMatches: 'Total Matches',
  wins: 'Wins',
  losses: 'Losses',
  winRate: 'Win Rate',
  currentStreak: 'Current Streak',
  winsInARow: 'wins in a row',
  keepItGoing: 'Keep it going!',
  performance: 'Performance',
  matchesPlayed: 'Matches Played',
  hoursOnCourt: 'Hours on Court',
  
  // Time
  today: 'Today',
  yesterday: 'Yesterday',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  
  // Messages
  loading: 'Loading...',
  noData: 'No data available',
  error: 'An error occurred',
  success: 'Success',
};
